module.exports = __webpack_public_path__ + "assets/img/zbt_b.21564a28.png";